export const SET_INITIAL_DATA = "SET_INITIAL_DATA"
export const SET_CURRENT_USER_DATA = "SET_CURRENT_USER_DATA"
export const SET_USER_ACCOUNTS = "SET_USER_ACCOUNTS"
export const DELETE_USER = "DELETE_USER"

export const setInitialData = (data) => ({
    type: SET_INITIAL_DATA,
    data
})

export const setUserAccounts = (data = []) => ({
    type: SET_USER_ACCOUNTS,
    data
})

export const setUserData = (data) => ({
    type: SET_CURRENT_USER_DATA,
    data
})

export const deleteUser = (data) => ({
    type: DELETE_USER,
    data
})